import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { ForgotPassword } from "../../../@types/auth";
import axiosInstance from "../../../api/manageServer";
import { AppDispatch } from "../../store";

interface AuthState {
  isLoading: boolean;
  error: string | false;
  tokenType: string;
  forgotPassword: any;
}

const initialState: AuthState = {
  isLoading: false,
  error: false,
  tokenType: "Bearer",
  forgotPassword: null,
};

const slice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    forgotPasswordSuccess(state, action: PayloadAction<any>) {
      state.isLoading = false;
      state.forgotPassword = action.payload;
    },
    forgotPasswordFailure(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetForgotPassword(state) {
      state.forgotPassword = null;
      state.error = false;
      state.isLoading = false;
    },
  },
});

// Export reducer
export default slice.reducer;

const { actions } = slice;

// Thunk function to handle forgot password
export function AuthForgotPassword(forgotPassword: ForgotPassword) {
  return async (dispatch: AppDispatch) => {
    dispatch(actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `auth/forgotPassword/${forgotPassword.email}`,
        forgotPassword
      );
      if (response?.data) {
        dispatch(actions.forgotPasswordSuccess(response.data));
        toast.success(response?.data?.message );
      } else {
        toast.error("Unexpected error occurred.");
      }
      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Request failed.";
      dispatch(actions.forgotPasswordFailure(errorMessage));
      toast.error(errorMessage);
    }
  };
}
